// @ts-nocheck
const CDN_BASE_URL = process.env.CDN_BASE_URL ? process.env.CDN_BASE_URL : process.env.BASE_URL;
export const environment = {
  production: true,
  MIX_PANEL_TOKEN: "b7cc468c0d435294be55d500bad4ea8c",
  SERVICES_BASE_PATH: "/studio/",
  BASE_URL: process.env.BASE_URL,
  CDN_BASE_URL: CDN_BASE_URL,
  BUILD_NUMBER: process.env.BUILD_NUMBER
};
